/**
 * trimValues recursively trims leading/trailing whitespace from string values in
 * a nested addon values object, so a stray space pasted into a field (e.g. an
 * image tag) doesn't reach Helm and break the release. Non-string leaves are
 * left unchanged.
 */
export function trimValues(
  values: Record<string, unknown>
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(values).map(([key, value]) => [key, trimValue(value)])
  );
}

function trimValue(value: unknown): unknown {
  if (typeof value === 'string') {
    return value.trim();
  }
  if (Array.isArray(value)) {
    return value.map(trimValue);
  }
  if (isRecord(value)) {
    return trimValues(value);
  }
  return value;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
